document.addEventListener('DOMContentLoaded', function () { 
   class YGPopupBox extends HTMLElement {
    constructor() {
      super();
      this.clickClosePopup = this.clickClosePopup.bind(this);
      this.clickOpenPopup = this.clickOpenPopup.bind(this);
      this.$contentInner = null;
    }

    connectedCallback() {
      this.$contentInner = this.querySelector('.yg-popup-box-content-inner');
      this.addEventListener('click', this.clickClosePopup)
      document.addEventListener("YGPopup:open", this.clickOpenPopup)
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      document.removeEventListener('YGPopupBox:open', this.handleOpenEvent);
    }

    clickOpenPopup(event) {
      const {$popupTemplate, fn} = event.detail;
      this.openPopup($popupTemplate, fn);
    }

    clickClosePopup(e) {
      this.closePopup(e, () => {
      });
    }

    openPopup($popupTemplate, fn) {
      // popupTemplate：需要替换的元素
      if (!$popupTemplate || !this.$contentInner) return;
      this.$contentInner.innerHTML = $popupTemplate.innerHTML;
      
      document.body.style.overflow = 'hidden';
      this.style.display = 'flex';

      const videoEl = this.$contentInner.querySelector('video');
      if (videoEl) {
        videoEl.muted = true; // 浏览器策略要求静音
        videoEl.playsInline = true; // iOS Safari 需要
        videoEl.autoplay = true;
        videoEl.play().catch((err) => {
          console.warn('自动播放失败:', err);
        });
      }
      typeof fn === 'function' && fn();
    }

    closePopup(e, fn) {
      let closeClassName = ["yg-popup-box-close", "yg-popup-box"]
      if (closeClassName.some(className => e.target.classList.contains(className))) {
        this.style.display = 'none';
        this.$contentInner.innerHTML = '';
        document.body.style.overflow = 'auto';
        typeof fn === 'function' && fn();
      }
    }
  }

  if (!window.customElements.get('yg-popup-box')) {
    window.customElements.define('yg-popup-box', YGPopupBox);
  }

  class YGOpenPopup extends HTMLElement {
    constructor() {
      super();
      this.itemClick = this.itemClick.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.itemClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.itemClick);
    }

    itemClick() {
      let $popupTemplate = this.querySelector('template') || this.querySelector('.yg-popup-template');

      console.log("$popupTemplate: ", $popupTemplate)
      if ($popupTemplate) {
        document.dispatchEvent(new CustomEvent("YGPopup:open", {
          bubbles: true,
          detail: {
            $popupTemplate,
            fn: () => {
            }
          }
        }))
      }
    }
  }

  if (!window.customElements.get('yg-open-popup')) {
    window.customElements.define('yg-open-popup', YGOpenPopup);
  }

  class YGDeferredMedia extends HTMLElement {
    constructor() {
      super();
    }

    static get observedAttributes() {
      return ['playing'];
    }

    connectedCallback() {
      this.bindPosterButton();

      this.addEventListener('click', (e) => {
        const video = this.querySelector('video')
        if (
          video &&
          e.target === video &&
          !video.hasAttribute('controls')
        ) {
          e.preventDefault()
          e.stopPropagation()
          if (this.playing) {
            this.pause()
          } else {
            this.play()
          }
        }
      });

      if (this.autoplay) {
        this.inViewObserver = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.init();
            } else {
              this.pause();
            }
          });
        });
        this.inViewObserver.observe(this);
      }
    }

    get posterElement() {
      return this.querySelector('[id^="YG-DeferredPoster-"]');
    }

    get autoplay() {
      return this.hasAttribute('autoplay');
    }

    get playing() {
      return this.hasAttribute('playing');
    }

    get player() {
      return this.playerProxy = this.playerProxy || new Proxy(this.playerTarget(), {
        get: (target, prop) => {
          return async () => {
            target = await target;
            this.playerHandler(target, prop);
          };
        }
      });
    }

    bindPosterButton() {
      const poster = this.posterElement;
      if (poster && !poster.hasListener) {
        poster.addEventListener('click', this.onPosterClick.bind(this));
        poster.hasListener = true;
      }
    }

    async playerTarget() {
      const template = this.querySelector('template');
      if (!template) return Promise.resolve(null);

      if (!this.mediaElement) {
        const fragment = template.content.cloneNode(true);
        this.appendChild(fragment);
        this.mediaElement = this.querySelector('video, iframe');
      }

      this.bindPosterButton();
      return Promise.resolve(this.mediaElement);
    }

    playerHandler(target, prop) {
      if (!target) return;

      if (prop === 'play' && typeof target.play === 'function') {
        target.play();
        this.setAttribute('playing', '');
        this.removeAttribute('paused');
      }

      if (prop === 'pause' && typeof target.pause === 'function') {
        target.pause();
        this.removeAttribute('playing');
        this.setAttribute('paused', '');
      }
    }

    onPosterClick(event) {
      event.preventDefault();
      event.stopPropagation();

      if (this.playing) {
        this.pause();
      } else {
        this.play();
      }
    }

    init() {
      if (!this.paused) {
        this.play();
      }
      return () => this.pause();
    }

    play() {
      if (!this.playing) {
        this.player.play();
      }
    }

    pause() {
      if (this.playing) {
        this.player.pause();
      }
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (name === 'playing') {
        if (oldValue === null && newValue === '') {
          this.dispatchEvent(new CustomEvent('video:play', {bubbles: true}));
          this.removeAttribute('paused');
        }
        if (newValue === null) {
          this.dispatchEvent(new CustomEvent('video:pause', {bubbles: true}));
          this.setAttribute('paused', '');
        }
      }
    }
  }

  class YGMedia extends YGDeferredMedia {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback(); // 保留父类逻辑

      if (!this.querySelector('img') && !this.hasAttribute('autoplay')) {
        this.inViewObserverNoAutoplay = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.loadMediaOnly();
              this.inViewObserverNoAutoplay.disconnect();
            }
          });
        });
        this.inViewObserverNoAutoplay.observe(this);
      }
    }

    async loadMediaOnly() {
      if (!this.mediaElement) {
        const template = this.querySelector('template');
        if (template) {
          const fragment = template.content.cloneNode(true);
          this.appendChild(fragment);
          this.mediaElement = this.querySelector('video, iframe');
          this.setAttribute('loaded', '');
          this.closest('.media')?.classList.remove('loading');
          this.bindPosterButton();
        }
      }
    }

    async playerTarget() {
      if (this.hasAttribute('host')) {
        this.setAttribute('loaded', '');
        this.closest('.media')?.classList.remove('loading');

        return new Promise(async (resolve) => {
          const templateElement = this.querySelector('template');
          if (templateElement) {
            templateElement.replaceWith(templateElement.content.firstElementChild.cloneNode(true));
          }
          this.bindPosterButton();

          const muteVideo = this.hasAttribute('autoplay') || window.matchMedia('(max-width: 1023px)').matches;
          const host = this.getAttribute('host');

          if (host === 'youtube') {
            if (!window.YT || !window.YT.Player) {
              await new Promise(res => {
                const script = document.createElement('script');
                script.src = 'https://www.youtube.com/iframe_api';
                script.onload = res;
                document.head.appendChild(script);
              });
              await new Promise(res => {
                window.onYouTubeIframeAPIReady = res;
              });
            }

            const player = new YT.Player(this.querySelector('iframe'), {
              events: {
                onReady: () => {
                  if (muteVideo) player.mute();
                  resolve(player);
                },
                onStateChange: (event) => {
                  if (event.data === YT.PlayerState.PLAYING) {
                    this.setAttribute('playing', '');
                    this.removeAttribute('paused');
                  }
                  if (event.data === YT.PlayerState.PAUSED || event.data === YT.PlayerState.ENDED) {
                    this.removeAttribute('playing');
                    this.setAttribute('paused', '');
                  }
                }
              }
            });
          }

          if (host === 'vimeo') {
            if (!window.Vimeo || !window.Vimeo.Player) {
              await new Promise(res => {
                const script = document.createElement('script');
                script.src = 'https://player.vimeo.com/api/player.js';
                script.onload = res;
                document.head.appendChild(script);
              });
            }

            const player = new Vimeo.Player(this.querySelector('iframe'));
            if (muteVideo) await player.setMuted(true);

            player.on('play', () => {
              this.setAttribute('playing', '');
              this.removeAttribute('paused');
            });
            player.on('pause', () => {
              this.removeAttribute('playing');
              this.setAttribute('paused', '');
            });
            player.on('ended', () => {
              this.removeAttribute('playing');
              this.setAttribute('paused', '');
            });

            resolve(player);
          }

          if (host === 'pimmedia') {
            // 假设 pimmedia 的 iframe 已经在页面上
            const iframe = this.querySelector('iframe');
            console.log("第三季我")
            if (!iframe) {
              console.warn('pimmedia iframe not found');
              return;
            }

            // 假设 mute 需要 postMessage 或类似接口，这里根据你具体接口改写
            if (muteVideo) {
              // 这里看你的 pimmedia 播放器怎么静音，比如 postMessage
              iframe.contentWindow.postMessage({action: 'mute'}, '*');
            }

            // 监听 pimmedia 的消息事件（例如播放、暂停、结束）
            window.addEventListener('message', (event) => {
              // 确认是 pimmedia 的消息，可根据 event.origin 做验证
              const data = event.data;

              if (typeof data !== 'object' || !data.event) return;

              if (data.event === 'play') {
                this.setAttribute('playing', '');
                this.removeAttribute('paused');
              }
              if (data.event === 'pause' || data.event === 'ended') {
                this.removeAttribute('playing');
                this.setAttribute('paused', '');
              }
            });

            // 返回一个模拟的 player 对象给 resolve
            resolve({
              play() {
                iframe.contentWindow.postMessage({action: 'play'}, '*');
              },
              pause() {
                iframe.contentWindow.postMessage({action: 'pause'}, '*');
              },
              mute() {
                iframe.contentWindow.postMessage({action: 'mute'}, '*');
              }
            });
          }
        });
      } else {
        const templateElement = this.querySelector('template');
        if (templateElement) {
          templateElement.replaceWith(templateElement.content.firstElementChild.cloneNode(true));
        }
        this.setAttribute('loaded', '');
        this.closest('.media')?.classList.remove('loading');

        const player = this.querySelector('video');
        player.addEventListener('play', () => {
          this.setAttribute('playing', '');
          this.removeAttribute('paused');
          this.removeAttribute('suspended');
        });
        player.addEventListener('pause', () => {
          if (!player.seeking && player.paused) {
            this.removeAttribute('playing');
            this.setAttribute('paused', '');
          }
        });

        this.bindPosterButton();
        return player;
      }
    }

    playerHandler(target, prop) {
      const host = this.getAttribute('host');

      if (host === 'youtube') {
        if (prop === 'play') {
          target.playVideo();
          this.setAttribute('playing', '');
          this.removeAttribute('paused');
        } else {
          target.pauseVideo();
          this.removeAttribute('playing');
          this.setAttribute('paused', '');
        }
      } else if (host === 'vimeo') {
        if (prop === 'play') {
          target.play();
          this.setAttribute('playing', '');
          this.removeAttribute('paused');
        } else {
          target.pause();
          this.removeAttribute('playing');
          this.setAttribute('paused', '');
        }
      } else {
        if (prop === 'play') {
          target.play().catch((error) => {
            if (error.name === 'NotAllowedError') {
              this.setAttribute('suspended', '');
              target.controls = true;
              const replacementImageSrc = target.previousElementSibling?.currentSrc;
              if (replacementImageSrc) {
                target.poster = replacementImageSrc;
              }
            }
          });
          this.setAttribute('playing', '');
          this.removeAttribute('paused');
        } else {
          target.pause();
          this.removeAttribute('playing');
          this.setAttribute('paused', '');
        }
      }
    }
  }

  if (!customElements.get('yg-video')) {
    customElements.define('yg-video', YGMedia);
  }

  class YGProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.initSwiper();
    }
    initSwiper() {
      new Swiper(this, {
        slidesPerView: 1.7,
        spaceBetween: 12,
        breakpoints: {
          750: {
            slidesPerView: this.getAttribute('data-desktop'),
            spaceBetween: 20,
          }
        },
        navigation : {
          nextEl: this.querySelector('.swiper-button-next'),
          prevEl: this.querySelector('.swiper-button-prev'),
        },
        pagination: {
          el: this.querySelector('.swiper-pagination'),
          clickable: true,
          type: 'progressbar',
        },
      })
    }
    
  }

  if (!window.customElements.get("yg-product-recommendations")) {
    window.customElements.define("yg-product-recommendations", YGProductRecommendations);
  }

  class YGFullPlayVideo extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      const video = this.querySelector('.yg-video');

      // 点击视频时：进入全屏 + 播放
      video.addEventListener('click', async () => {
        const isFullscreen = document.fullscreenElement === video ||
                            document.webkitFullscreenElement === video ||
                            document.msFullscreenElement === video;

        if (isFullscreen) return; // 已全屏，防止重复执行

        try {
          video.controls = true;
          video.muted = false;

          // 进入全屏
          if (video.requestFullscreen) {
            await video.requestFullscreen();
          } else if (video.webkitRequestFullscreen) {
            await video.webkitRequestFullscreen();
          } else if (video.msRequestFullscreen) {
            await video.msRequestFullscreen();
          }

          await video.play();
        } catch (err) {
          console.error("全屏或播放失败:", err);
        }
      });

      // 退出全屏时：隐藏控件 + 静音 + 自动播放 + 重置视频状态
      const exitHandler = () => {
        const isStillFullscreen =
          document.fullscreenElement ||
          document.webkitFullscreenElement ||
          document.msFullscreenElement;

        if (!isStillFullscreen) {
          // 重置 video 状态，兼容 vivo 和国产安卓浏览器
          video.controls = false;
          video.muted = true;

          video.pause();
          video.currentTime = 0;
          video.load();
          video.play().catch(err => {
            console.warn("退出后自动播放失败:", err);
          });

        

          setTimeout(() => {
            this.scrollIntoView({
              block: "center",
            });
          }, 1000);
          
        }
      };

      // 添加兼容的全屏事件监听器
      document.addEventListener("fullscreenchange", exitHandler);
      document.addEventListener("webkitfullscreenchange", exitHandler);
      document.addEventListener("msfullscreenchange", exitHandler);
    }
  }

  // 注册自定义组件
  if (!window.customElements.get("yg-full-play-video")) {
    window.customElements.define("yg-full-play-video", YGFullPlayVideo);
  }

  class SlideSection extends HTMLElement {
    constructor() {
      super();
      this.globalSlide = null;
      setTimeout(() => {
        this.init();
      }, 50);
    }

    init() {
      if (document.body.classList.contains('index')) {
        let pos = window.pageYOffset;
        if (pos > 0 || document.body.classList.contains('swiper-lazy')) {
          this.initSlide();
        } else {
          if (this.classList.contains('lazy-loading-swiper-before')) {
            this.initSlide();
          } else {
            this.classList.add('lazy-loading-swiper-after');
          }
        }
      } else {
        this.initSlide();
      }
    }

    initSlide() {
      const _this = this;
      var autoplaying = _this?.dataset.autoplay === 'true';
      const loop = _this?.dataset.loop === 'true';
      const itemDesktop = _this?.dataset.desktop ? _this?.dataset.desktop : 4;
      var itemTablet = _this?.dataset.tablet ? _this?.dataset.tablet : '';
      const itemMobile = _this?.dataset.mobile ? _this?.dataset.mobile : 1;
      const direction = _this?.dataset.direction ? _this?.dataset.direction : 'horizontal';
      var autoplaySpeed = _this?.dataset.autoplaySpeed ? _this?.dataset.autoplaySpeed * 1000 : 3000;
      var speed = _this?.dataset.speed ? _this?.dataset.speed : 400;
      const effect = _this?.dataset.effect ? _this?.dataset.effect : 'slide';
      const row = _this?.dataset.row ? _this?.dataset.row : 1;
      var spacing = _this?.dataset.spacing ? _this?.dataset.spacing : 30;
      var mobile_spacing = _this?.dataset.mobileSpacing ? _this?.dataset.mobileSpacing : spacing;
      const progressbar = _this?.dataset.paginationProgressbar === 'true';
      const autoItem = _this?.dataset.itemMobile === 'true';
      const autoHeight = _this?.dataset.autoHeight === 'true';
      const arrowCenterimage = _this?.dataset.arrowCenterimage ? _this?.dataset.arrowCenterimage : 0;
      const nextEl = document.querySelector(_this.dataset.nextEl);
      const prevEl = document.querySelector(_this.dataset.prevEl);
      spacing = Number(spacing);
      mobile_spacing = Number(mobile_spacing);
      autoplaySpeed = Number(autoplaySpeed);
      speed = Number(speed);
      if (autoplaying) {
        autoplaying = { delay: autoplaySpeed };
      }
      if (!itemTablet) {
        if (itemDesktop < 2) {
          itemTablet = 1;
        } else if (itemDesktop < 3) {
          itemTablet = 2;
        } else {
          itemTablet = 3;
        }
      }
      if (direction == 'vertical') {
        _this.style.maxHeight = _this.offsetHeight + 'px';
      }

      const defaultOption = {
        slidesPerView: autoItem ? 'auto' : itemMobile,
        spaceBetween: mobile_spacing >= 15 ? 15 : mobile_spacing,
        autoplay: autoplaying,
        direction: direction,
        loop: loop,
        effect: effect,
        autoHeight: autoHeight,
        speed: speed,
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        grid: {
          rows: row,
          fill: 'row',
        },
        navigation: {
          nextEl: nextEl || _this.querySelector('.swiper-button-next, .swiper-nav-next'),
          prevEl: prevEl || _this.querySelector('.swiper-button-prev, .swiper-nav-prev'),
        },
        pagination: {
          clickable: true,
          el: _this.querySelector('.parent-pagination') || _this.querySelector('.swiper-pagination'),
          type: progressbar ? 'progressbar' : 'bullets',
        },
        breakpoints: {
          768: {
            slidesPerView: itemTablet,
            spaceBetween: spacing >= 30 ? 30 : spacing,
            type: progressbar ? 'progressbar' : 'bullets',
            autoHeight: false,
          },
          1025: {
            slidesPerView: itemDesktop,
            spaceBetween: spacing,
            type: progressbar ? 'progressbar' : 'bullets',
            autoHeight: false,
          },
        },
        thumbs: {
          swiper: this.thumbnailSlide ? this.thumbnailSlide : null,
        },

        on: {
          init: function (e) {
            var sec__tiktok = _this.closest('.sec__tiktok-video');
            if (_this.classList.contains('slideshow')) {
              const motionElement = _this.querySelectorAll(
                `.swiper-slide.swiper-slide-active  motion-element.effect_fadeinup`
              );
              setTimeout(() => {
                motionElement &&
                  motionElement.forEach((item) => {
                    item.refreshAnimation();
                  });
              }, 350);
            }
            var slide_visibles = _this.querySelectorAll(
              '.swiper-slide:not(.swiper-slide-visible) motion-element:not([data-image]),motion-element.swiper-slide:not(.swiper-slide-visible)'
            );
            slide_visibles?.forEach((slide) => {
              if (slide && typeof slide.initialize === 'function') {
                slide.initialize();
              }
            });
            e.autoplay.stop();
            if (_this?.dataset.autoplay === 'true') {
              motion.inView(
                _this,
                async () => {
                  e.autoplay.start();
                },
                { margin: '0px 0px -50px 0px' }
              );
            }

            if (sec__tiktok) {
              _this.initSecTiktok(sec__tiktok);
              window.addEventListener('resize', function () {
                setTimeout(() => {
                  _this.initSecTiktok(sec__tiktok);
                }, 150);
              });
            }
            if (arrowCenterimage) {
              var items_slide = _this.querySelectorAll('.product-item__media--ratio');
              if (items_slide.length != 0) {
                var oH = [];
                items_slide.forEach((e) => {
                  oH.push(e.offsetHeight / 2);
                });
                var max = Math.max(...oH);
                var arrowsOffset = '--arrows-offset-top: ' + max + 'px';
                if (_this.querySelectorAll('.swiper-arrow')) {
                  _this.querySelectorAll('.swiper-arrow').forEach((arrow) => {
                    arrow.setAttribute('style', arrowsOffset);
                  });
                }
              }
            }
            var video = _this.querySelector('video.slideshow');
            if (video) {
              const handleIntersection = (entries, observer) => {
                if (!entries[0].isIntersecting) return;
                observer.unobserve(_this);
                const videos = _this.querySelectorAll('video');
                videos.forEach((video) => {
                  const dataSrc = video.dataset.src;
                  if (dataSrc) {
                    video.src = dataSrc;
                    video.removeAttribute('data-src');
                  }
                });
              };
              new IntersectionObserver(handleIntersection.bind(_this), {
                rootMargin: '0px 0px 200px 0px',
              }).observe(_this);
            }
          },
          realIndexChange: function (swiper) {
            if (_this?.dataset.autoplay) {
              var slide_visibles = _this.querySelectorAll('.swiper-slide motion-element:not([data-image])');
              slide_visibles?.forEach((slide) => {
                if (!slide.hasAttribute('hold')) {
                  slide?.setAttribute('hold', true);
                }
              });
            } else {
              var slide_visibles = _this.querySelectorAll('.swiper-slide motion-element:not([data-image])');
              slide_visibles?.forEach((slide) => {
                if (!slide.hasAttribute('hold')) {
                  slide?.setAttribute('hold', true);
                }
              });
            }

            setTimeout(() => {
              if (_this.classList.contains('slideshow')) {
                const motionElement = _this.querySelectorAll(
                  `.swiper-slide.swiper-slide-active  motion-element.effect_fadeinup, .swiper-slide.swiper-slide-active  motion-element.motion-image`
                );
                motionElement &&
                  motionElement.forEach((item) => {
                    item.refreshAnimation();
                  });
              }
            }, 50);
          },
          slideChange: function () {
            const index_currentSlide = this.realIndex + 1;
            if (_this.closest('.sec__testimonials-single')) {
              const allDots = _this.closest('.sec__testimonials-single').querySelectorAll(`single-item`);
              allDots.forEach((dot) => {
                dot.classList.remove('active');
              });
              _this
                .closest('.sec__testimonials-single')
                .querySelector(".testimonials-author-image[data-position='" + index_currentSlide + "']")
                .classList.add('active');
            }
          },
          afterInit() {
            _this.dispatchEvent(new Event('afterInit', { detail: _this.globalSlide }));
          },
        },
      };
      let additionalSwiperOptions = {};
      if (_this?.dataset.swiperOptions) {
        if (_this?.dataset.swiperOptions.trim().charAt(0) === '{') {
          additionalSwiperOptions = JSON.parse(_this?.dataset.swiperOptions);
        } else if (_this?.dataset.swiperOptions.startsWith('window.')) {
          additionalSwiperOptions = window[_this?.dataset.swiperOptions.slice(7)];
        } else if (_this?.dataset.swiperOptions.startsWith('window[')) {
          const key = _this?.dataset.swiperOptions.match(/window\[['"](.+?)['"]\]/)[1];
          additionalSwiperOptions = window[key];
        }
      }
      const swiperOptions = { ...defaultOption, ...additionalSwiperOptions };

      this.globalSlide = new Swiper(_this, swiperOptions);
    }

    initSecTiktok(sec) {
      sec.querySelectorAll('.swiper-slide').forEach((arrow) => {
        const tiktok = arrow.querySelector('.section_tiktok-image');
        let width = '--item-width: ' + arrow.offsetWidth;
        tiktok.setAttribute('style', width);
      });
    }
  }
  if (!window.customElements.get("slide-section")) {
    window.customElements.define("slide-section", SlideSection);
  }
  
  class YGRelatedProduct extends SlideSection {
    constructor() {
      super();
    }
    init() {
      this.call();
    }
    call() {
      
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            console.log('text',text);
            
            const html = document.createElement("div");
            html.innerHTML = text;
            const recommendations = html.querySelector("yg-related-product");
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
            if (recommendations.innerHTML.trim().length === 0) {
              // this.remove();
              this.style.display = "none";
              if (document.querySelector(".product-recommendations-heading")) {
                document
                  .querySelector(".product-recommendations-heading")
                  .remove();
              }
            }
          })
          .finally(() => {
            console.log(2222);
            
            if (this.querySelector(".swiper-wrapper")) {
              this.initSlide();
              BlsAnimations.innit();
              BlsLazyloadImg.init();          
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: "0px 0px 400px 0px",
      }).observe(this);
    }
  }

  if (!window.customElements.get("yg-related-product")) {
    window.customElements.define("yg-related-product", YGRelatedProduct);
  }

  // YG Swiper Slider Web Component
  class YGSwiperSlider extends HTMLElement {
    constructor() {
      super();
      this.swiperInstance = null;
    }

    connectedCallback() {
      // 等待 Swiper 加载
      if (typeof Swiper === 'undefined') {
        const checkSwiper = setInterval(() => {
          if (typeof Swiper !== 'undefined') {
            clearInterval(checkSwiper);
            this.initSwiper();
          }
        }, 100);
      } else {
        this.initSwiper();
      }
    }

    disconnectedCallback() {
      if (this.swiperInstance) {
        this.swiperInstance.destroy(true, true);
      }
    }

    initSwiper() {
      // 从 data 属性读取配置
      const slidesPerView = parseFloat(this.dataset.slidesPerView) || 1.5;
      const slidesPerViewMd = parseFloat(this.dataset.slidesPerViewMd) || 2.5;
      const spaceBetween = parseInt(this.dataset.spaceBetween) || 20;
      const spaceBetweenMd = parseInt(this.dataset.spaceBetweenMd) || 24;
      const centeredSlides = this.dataset.centeredSlides === 'true';
      
      // 查找已存在的 DOM 元素
      const paginationEl = this.querySelector('.swiper-pagination');
      const nextButton = this.querySelector('.swiper-button-next');
      const prevButton = this.querySelector('.swiper-button-prev');

      // 构建 Swiper 配置
      const swiperConfig = {
        slidesPerView: slidesPerView,
        spaceBetween: spaceBetween,
        centeredSlides: centeredSlides,
        breakpoints: {
          768: {
            slidesPerView: slidesPerViewMd,
            spaceBetween: spaceBetweenMd,
          }
        }
      };

      // 如果存在分页器，添加分页配置
      if (paginationEl) {
        swiperConfig.pagination = {
          el: paginationEl,
          clickable: true,
        };
      }

      // 如果存在导航按钮，添加导航配置
      if (nextButton && prevButton) {
        swiperConfig.navigation = {
          nextEl: nextButton,
          prevEl: prevButton,
        };
      }

      // 初始化 Swiper
      this.swiperInstance = new Swiper(this, swiperConfig);
    }
  }

  if (!window.customElements.get("yg-swiper-slider")) {
    window.customElements.define("yg-swiper-slider", YGSwiperSlider);
  }

  // YG Card List Swiper Web Component
  class YGCardListSwiper extends HTMLElement {
    constructor() {
      super();
      this.swiperInstance = null;
    }

    connectedCallback() {
      // 等待 Swiper 加载
      if (typeof Swiper === 'undefined') {
        const checkSwiper = setInterval(() => {
          if (typeof Swiper !== 'undefined') {
            clearInterval(checkSwiper);
            this.initSwiper();
          }
        }, 100);
      } else {
        this.initSwiper();
      }
    }

    disconnectedCallback() {
      if (this.swiperInstance) {
        this.swiperInstance.destroy(true, true);
      }
    }

    initSwiper() {
      // 初始化 Swiper
      this.swiperInstance = new Swiper(this, {
        slidesPerView: 1.2,
        spaceBetween: 12,
        centeredSlides: false,
        freeMode: true,
        freeModeMomentum: true,
        freeModeSticky: false,
        breakpoints: {
          750: {
            slidesPerView: 'auto',
            spaceBetween: 12,
            freeMode: true,
            freeModeMomentum: true,
            freeModeSticky: false,
            resistanceRatio: 0.85,
          },
          1440: {
            slidesPerView: 'auto',
            spaceBetween: 12,
            freeMode: true,
            freeModeMomentum: true,
            freeModeSticky: false,
            resistanceRatio: 0.85,
          }
        }
      });
    }
  }

  if (!window.customElements.get("yg-card-list-swiper")) {
    window.customElements.define("yg-card-list-swiper", YGCardListSwiper);
  }

  // Product Popup Tab Switching
  class YGProductPopup extends HTMLElement {
    constructor() {
      super();
      this.swiperInstances = {};
      this.initTabs();
      this.initSwipers();
    }

    initTabs() {
      const tabButtons = this.querySelectorAll('.yg-product-tab-btn');
      const tabPanels = this.querySelectorAll('.yg-product-tab-panel');
      const tabDescriptions = this.querySelectorAll('.yg-product-tab-description');

      tabButtons.forEach(button => {
        button.addEventListener('click', () => {
          const tabIndex = button.getAttribute('data-tab-index');

          // 移除所有激活状态
          tabButtons.forEach(btn => btn.classList.remove('yg-product-tab-btn--active'));
          tabPanels.forEach(panel => panel.classList.remove('yg-product-tab-panel--active'));
          tabDescriptions.forEach(desc => desc.classList.remove('yg-product-tab-description--active'));

          // 添加当前激活状态
          button.classList.add('yg-product-tab-btn--active');
          
          const activePanel = this.querySelector(`[data-tab-panel="${tabIndex}"]`);
          if (activePanel) {
            activePanel.classList.add('yg-product-tab-panel--active');
          }

          const activeDescription = this.querySelector(`[data-tab-description="${tabIndex}"]`);
          if (activeDescription) {
            activeDescription.classList.add('yg-product-tab-description--active');
          }

          // 更新当前 tab 的 Swiper
          const swiper = activePanel?.querySelector('.yg-product-swiper');
          if (swiper && swiper.swiper) {
            swiper.swiper.update();
          }
        });
      });
    }

    initSwipers() {
      // 等待 Swiper 加载
      if (typeof Swiper === 'undefined') {
        const checkSwiper = setInterval(() => {
          if (typeof Swiper !== 'undefined') {
            clearInterval(checkSwiper);
            this.createSwipers();
          }
        }, 100);
      } else {
        this.createSwipers();
      }
    }

    createSwipers() {
      const swiperElements = this.querySelectorAll('.yg-product-swiper');
      
      swiperElements.forEach(swiperEl => {
        const swiperId = swiperEl.getAttribute('data-swiper-id');
        
        // 查找对应的导航按钮
        const nextButton = this.querySelector(`.yg-product-swiper-next[data-swiper-id="${swiperId}"]`);
        const prevButton = this.querySelector(`.yg-product-swiper-prev[data-swiper-id="${swiperId}"]`);

        // 初始化 Swiper
        const swiperInstance = new Swiper(swiperEl, {
          slidesPerView: 2.5,
          spaceBetween: 24,
          navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
          },
          breakpoints: {
            768: {
              slidesPerView: 2.5,
              spaceBetween: 24,
            },
            1024: {
              slidesPerView: 2.5,
              spaceBetween: 24,
            }
          },
          on: {
            init: function() {
              // Swiper 初始化完成
            }
          }
        });

        // 保存实例
        this.swiperInstances[swiperId] = swiperInstance;
      });
    }

    disconnectedCallback() {
      // 销毁所有 Swiper 实例
      Object.values(this.swiperInstances).forEach(swiper => {
        if (swiper && swiper.destroy) {
          swiper.destroy(true, true);
        }
      });
    }
  }

  if (!window.customElements.get("yg-product-popup")) {
    window.customElements.define("yg-product-popup", YGProductPopup);
  }

    /* BM08 */
  class YGBMHeader extends HTMLElement {
    constructor() {
      super();
      this.timeline = null;
    }

    connectedCallback() {
      this.initAnimation();
    }

    initAnimation() {
      if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
        console.warn('GSAP 或 ScrollTrigger 未加载');
        return;
      }

      gsap.registerPlugin(ScrollTrigger);

      const subheading = this.querySelector('.section__header-subheading')
      const heading = this.querySelector('.section__header-heading');
      const heading_mobile = this.querySelector('.section__header-heading-mobile');
      const description = this.querySelector('.section__header-des');

      this.timeline = gsap.timeline({
        scrollTrigger: {
          trigger: this,
          start: 'top 95%',
          toggleActions: 'play none none none',
          once: true,
        },
        onComplete: () => {
          // 触发自定义事件，通知动画完成
          this.dispatchEvent(new CustomEvent('header-animation-complete', { 
            bubbles: true 
          }));
        }
      });

      const elements = [subheading, heading, heading_mobile, description].filter(el => el);
      gsap.set(elements, { 
        opacity: 0, 
        y: 40 
      });

      elements.forEach((el, index) => {
        this.timeline.to(el, {
          opacity: 1,
          y: 0,
          duration: 0.8,
          ease: 'power2.out'
        }, index * 0.15);
      });
    }
  }

  if (!window.customElements.get("yg-bm-header")) {
    window.customElements.define("yg-bm-header", YGBMHeader);
  }

  class YGBMCardGrid extends HTMLElement {
    constructor() {
      super();
      this.shakeInterval = null;
      this.scrollTriggers = [];
      this.timelines = [];
      this.gsapCheckTimer = null;
      this.maxRetries = 50;
      this.retryCount = 0;
      this.intersectionObserver = null;
      this.animationInitialized = false;
    }

    connectedCallback() {
      this.initMediaToggle();
      this.initProductCardShake();
      this.init();
    }

    disconnectedCallback() {
      this.cleanup();
    }

    cleanup() {
      if (this.gsapCheckTimer) {
        clearTimeout(this.gsapCheckTimer);
        this.gsapCheckTimer = null;
      }

      if (this.shakeInterval) {
        clearInterval(this.shakeInterval);
        this.shakeInterval = null;
      }

      if (this.scrollTriggers.length > 0) {
        this.scrollTriggers.forEach((trigger) => {
          if (trigger) {
            trigger.kill();
          }
        });
        this.scrollTriggers = [];
      }

      if (this.timelines.length > 0) {
        this.timelines.forEach((timeline) => {
          if (timeline) {
            timeline.kill();
          }
        });
        this.timelines = [];
      }

      if (this.intersectionObserver) {
        this.intersectionObserver.disconnect();
        this.intersectionObserver = null;
      }
    }

    init() {
      const gridItems = this.querySelectorAll('.yg-image-text-grid-item');
      gridItems.forEach((item) => item.classList.add('is-ready'));

      setTimeout(() => {
        this.waitForGSAP();
      }, 100);
    }

    waitForGSAP() {
      if (this.retryCount >= this.maxRetries) {
        console.warn('YGBMCardGrid: GSAP 加载超时');
        return;
      }

      if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
        if (!this.animationInitialized) {
          this.initAnimation();
          this.animationInitialized = true;
        }
      } else {
        this.retryCount++;
        this.gsapCheckTimer = setTimeout(() => {
          this.waitForGSAP();
        }, 100);
      }
    }

    initMediaToggle() {
      const mediaContainers = this.querySelectorAll('.yg-media-container');

      mediaContainers.forEach((container) => {
        const toggleBtns = container.querySelectorAll('.yg-media-toggle-btn');
        const mediaItems = container.querySelectorAll('.yg-media-item');

        toggleBtns.forEach((btn) => {
          btn.addEventListener('click', function () {
            const targetType = this.getAttribute('data-toggle');

            toggleBtns.forEach((b) => b.classList.remove('active'));
            this.classList.add('active');

            mediaItems.forEach((item) => {
              const itemType = item.getAttribute('data-media-type');
              if (itemType === targetType) {
                item.classList.add('active');
                if (itemType === 'video') {
                  const video = item.querySelector('video');
                  if (video) {
                    video.currentTime = 0;
                    video.play();
                  }
                }
              } else {
                item.classList.remove('active');
                if (itemType === 'video') {
                  const video = item.querySelector('video');
                  if (video) {
                    video.pause();
                  }
                }
              }
            });
          });
        });
      });
    }

    initAnimation() {
      if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
        console.warn('YGBMCardGrid: GSAP 或 ScrollTrigger 未加载');
        return;
      }

      try {
        gsap.registerPlugin(ScrollTrigger);

        const mediaBox = this.querySelector('.yg-media-box');
        const gridContainer = this.querySelector('.yg-image-text-grid');

        if (!gridContainer) {
          console.warn('YGBMCardGrid: 未找到 gridContainer');
          return;
        }

        const gridItems = gridContainer.querySelectorAll('.yg-image-text-grid-item');

        // 如果有 mediaBox，添加动画
        if (mediaBox) {
          // 检查元素是否已经在视口内
          const mediaBoxRect = mediaBox.getBoundingClientRect();
          const isInView = mediaBoxRect.top < window.innerHeight && mediaBoxRect.bottom > 0;

          if (isInView) {
            // 如果已经在视口内，直接显示，不做动画
            gsap.set(mediaBox, { opacity: 1, y: 0 });
          } else {
            // 不在视口内，设置初始状态并添加滚动动画
            gsap.set(mediaBox, { opacity: 0, y: 0 });

            const mediaBoxTween = gsap.to(mediaBox, {
              opacity: 1,
              y: 0,
              duration: 0.8,
              ease: 'power2.out',
              scrollTrigger: {
                trigger: mediaBox,
                start: 'top 95%',
                toggleActions: 'play none none none',
                once: true,
              },
            });

            if (mediaBoxTween && mediaBoxTween.scrollTrigger) {
              this.scrollTriggers.push(mediaBoxTween.scrollTrigger);
            }
          }
        }

        if (gridItems.length > 0) {
          const gridRect = gridContainer.getBoundingClientRect();
          const isGridInView = gridRect.top < window.innerHeight * 0.8 && gridRect.bottom > 0;

          gsap.set(gridItems, { opacity: 0, visibility: 'visible' });

          if (isGridInView) {
            const gridTimeline = gsap.timeline();

            gridTimeline.to(gridItems, {
              opacity: 1,
              duration: 0.8,
              ease: 'power2.out',
              stagger: 0.15,
              clearProps: 'willChange',
            });

            this.timelines.push(gridTimeline);
          } else {
            const gridTimeline = gsap.timeline({
              scrollTrigger: {
                trigger: gridContainer,
                start: 'top 80%',
                toggleActions: 'play none none none',
                once: true,
              },
            });

            gridTimeline.to(gridItems, {
              opacity: 1,
              duration: 0.8,
              ease: 'power2.out',
              stagger: 0.15,
              clearProps: 'willChange',
            });

            this.timelines.push(gridTimeline);
            if (gridTimeline.scrollTrigger) {
              this.scrollTriggers.push(gridTimeline.scrollTrigger);
            }
          }
        }
      } catch (error) {
        console.error('YGBMCardGrid: 动画初始化失败', error);
      }
    }

    initProductCardShake() {
      const productCards = this.querySelectorAll('.yg-product-card');

      if (productCards.length === 0) return;

      this.intersectionObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.startShakeEffect(entry.target);
            } else {
              this.stopShakeEffect(entry.target);
            }
          });
        },
        {
          threshold: 0.5,
          rootMargin: '0px',
        }
      );

      productCards.forEach((card) => {
        this.intersectionObserver.observe(card);
      });
    }

    startShakeEffect(card) {
      if (this.shakeInterval) {
        clearInterval(this.shakeInterval);
      }

      this.performShake(card);

      this.shakeInterval = setInterval(() => {
        this.performShake(card);
      }, 5000);
    }

    performShake(card) {
      card.classList.remove('shake');
      void card.offsetWidth;
      card.classList.add('shake');

      setTimeout(() => {
        card.classList.remove('shake');
      }, 2500);
    }

    stopShakeEffect(card) {
      if (this.shakeInterval) {
        clearInterval(this.shakeInterval);
        this.shakeInterval = null;
      }

      card.classList.remove('shake');
    }
  }

  if (!customElements.get('yg-bm-card-grid')) {
    customElements.define('yg-bm-card-grid', YGBMCardGrid);
  }

  /* end BM08 */


  class YGAnimationHeader extends HTMLElement {
    constructor() {
      super();
      this.timeline = null;
    }

    connectedCallback() {
      this.initAnimation();
    }

    initAnimation() {
      if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
        console.warn('GSAP 或 ScrollTrigger 未加载');
        return;
      }

      gsap.registerPlugin(ScrollTrigger);

      const heading = this.querySelector('.section__header-heading');
      const description = this.querySelector('.section__header-des');
      const icon = this.querySelector('.yg-large-icon');

      this.timeline = gsap.timeline({
        scrollTrigger: {
          trigger: this,
          start: 'top 95%',
          toggleActions: 'play none none none',
          once: true,
        },
        onComplete: () => {
          // 触发自定义事件，通知动画完成
          this.dispatchEvent(new CustomEvent('header-animation-complete', { 
            bubbles: true 
          }));
        }
      });

      const elements = [heading, description, icon].filter(el => el);
      gsap.set(elements, { 
        opacity: 0, 
        y: 40 
      });

      elements.forEach((el, index) => {
        this.timeline.to(el, {
          opacity: 1,
          y: 0,
          duration: 0.8,
          ease: 'power2.out'
        }, index * 0.15);
      });
    }
  }

  if (!window.customElements.get("yg-animation-header")) {
    window.customElements.define("yg-animation-header", YGAnimationHeader);
  }

  // Scene V2 Banner Web Component
  class SceneV2Banner extends HTMLElement {
    constructor() {
      super();
      this.hasAnimated = false;
    }

    connectedCallback() {
      if (this.dataset.animation !== 'true') return;
      
      if (typeof gsap === 'undefined') {
        const checkGsap = setInterval(() => {
          if (typeof gsap !== 'undefined') {
            clearInterval(checkGsap);
            this.initAnimation();
          }
        }, 100);
      } else {
        this.initAnimation();
      }
    }

    initAnimation() {
      if (this.hasAnimated) return;
      this.hasAnimated = true;

      // 获取当前显示的图片（PC或移动端）
      const pcImage = this.querySelector('.pc-image');
      const mobileImage = this.querySelector('.mobile-image');
      const isMobile = window.innerWidth <= 768;
      const activeImage = isMobile ? mobileImage : pcImage;
      
      const title = this.querySelector('.scene-v2-header-banner-content-title');
      const description = this.querySelector('.scene-v2-header-banner-content-description');

      activeImage.style.willChange = 'transform';
      title.style.willChange = 'transform, opacity';
      description.style.willChange = 'transform, opacity';

      gsap.set(activeImage, { scale: 1.3 });
      gsap.set([title, description], { opacity: 0, y: 40 });

      const tl = gsap.timeline({
        onComplete: () => {
          activeImage.style.willChange = 'auto';
          title.style.willChange = 'auto';
          description.style.willChange = 'auto';
        }
      });

      tl.to(activeImage, {
        scale: 1,
        duration: 1.2,
        ease: 'power2.out',
        force3D: true
      }, 0);

      tl.to(title, {
        opacity: 1,
        y: 0,
        duration: 0.8,
        ease: 'power2.out',
        force3D: true
      }, 0.4);

      tl.to(description, {
        opacity: 1,
        y: 0,
        duration: 0.8,
        ease: 'power2.out',
        force3D: true
      }, 0.6);
    }
  }

  if (!window.customElements.get("scene-v2-banner")) {
    window.customElements.define("scene-v2-banner", SceneV2Banner);
  }

  // YG Image Text Animation Component
  class YGImageTextAnimation extends HTMLElement {
    constructor() {
      super();
      this.scrollTrigger = null;
      this.timeline = null;
      this.gsapCheckTimer = null;
      this.maxRetries = 20;
      this.retryCount = 0;
    }

    connectedCallback() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
          this.init();
        });
      } else {
        this.init();
      }
    }

    disconnectedCallback() {
      this.cleanup();
    }

    cleanup() {
      if (this.gsapCheckTimer) {
        clearTimeout(this.gsapCheckTimer);
        this.gsapCheckTimer = null;
      }

      if (this.scrollTrigger) {
        this.scrollTrigger.kill();
        this.scrollTrigger = null;
      }

      if (this.timeline) {
        this.timeline.kill();
        this.timeline = null;
      }
    }

    init() {
      this.waitForGSAP();
    }

    waitForGSAP() {
      if (this.retryCount >= this.maxRetries) {
        console.warn('YGImageTextAnimation: GSAP 加载超时');
        return;
      }

      if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
        this.initAnimation();
      } else {
        this.retryCount++;
        this.gsapCheckTimer = setTimeout(() => {
          this.waitForGSAP();
        }, 200);
      }
    }

    initAnimation() {
      if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
        return;
      }

      try {
        gsap.registerPlugin(ScrollTrigger);

        const contentItem = this.querySelector('.yg-content-item');
        if (!contentItem) return;

        const title = contentItem.querySelector('.yg-content-title');
        const desc = contentItem.querySelector('.yg-content-desc');
        const image = contentItem.querySelector('.yg-content-image');

        if (title) {
          gsap.set(title, { opacity: 0, y: 40 });
        }

        if (desc) {
          gsap.set(desc, { opacity: 0, y: 40 });
        }

        if (image) {
          gsap.set(image, { opacity: 0, y: 40 });
        }

        this.timeline = gsap.timeline({
          scrollTrigger: {
            trigger: contentItem,
            start: 'top 80%',
            toggleActions: 'play none none none',
            once: true,
            onEnter: (self) => {
              this.scrollTrigger = self;
            },
          },
        });

        if (title) {
          this.timeline.to(title, {
            opacity: 1,
            y: 0,
            duration: 0.8,
            ease: 'power2.out',
          }, 0);
        }

        if (desc) {
          this.timeline.to(desc, {
            opacity: 1,
            y: 0,
            duration: 0.8,
            ease: 'power2.out',
          }, 0.15);
        }

        if (image) {
          this.timeline.to(image, {
            opacity: 1,
            y: 0,
            duration: 0.8,
            ease: 'power2.out',
          }, 0.3);
        }
      } catch (error) {
        console.error('YGImageTextAnimation: 动画初始化失败', error);
      }
    }
  }

  if (!customElements.get('yg-image-text-animation')) {
    customElements.define('yg-image-text-animation', YGImageTextAnimation);
  }

  // YG Media Card Grid Animation Component
  class YGMediaCardGridAnimation extends HTMLElement {
    constructor() {
      super();
      this.shakeInterval = null;
      this.scrollTriggers = [];
      this.timelines = [];
      this.gsapCheckTimer = null;
      this.maxRetries = 50;
      this.retryCount = 0;
      this.intersectionObserver = null;
      this.animationInitialized = false;
    }

    connectedCallback() {
      // 先初始化非动画功能
      this.initMediaToggle();
      this.initProductCardShake();
      
      // 等待 Swiper 初始化后再初始化动画
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
          this.init();
        });
      } else {
        this.init();
      }
    }

    disconnectedCallback() {
      this.cleanup();
    }

    cleanup() {
      if (this.gsapCheckTimer) {
        clearTimeout(this.gsapCheckTimer);
        this.gsapCheckTimer = null;
      }

      if (this.shakeInterval) {
        clearInterval(this.shakeInterval);
        this.shakeInterval = null;
      }

      if (this.scrollTriggers.length > 0) {
        this.scrollTriggers.forEach((trigger) => {
          if (trigger) {
            trigger.kill();
          }
        });
        this.scrollTriggers = [];
      }

      if (this.timelines.length > 0) {
        this.timelines.forEach((timeline) => {
          if (timeline) {
            timeline.kill();
          }
        });
        this.timelines = [];
      }

      if (this.intersectionObserver) {
        this.intersectionObserver.disconnect();
        this.intersectionObserver = null;
      }
    }

    init() {
      // 先初始化 Swiper
      this.initSwiper();
      // 延迟初始化动画，确保 GSAP 已加载
      setTimeout(() => {
        this.waitForGSAP();
      }, 100);
    }

    waitForGSAP() {
      if (this.retryCount >= this.maxRetries) {
        console.warn('YGMediaCardGridAnimation: GSAP 加载超时');
        return;
      }

      if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
        if (!this.animationInitialized) {
          this.initAnimation();
          this.animationInitialized = true;
        }
      } else {
        this.retryCount++;
        this.gsapCheckTimer = setTimeout(() => {
          this.waitForGSAP();
        }, 100);
      }
    }

    initSwiper() {
      const swiperContainer = this.querySelector('.yg-image-text-grid');
      if (!swiperContainer) return;

      const initSwiperInstance = () => {
        if (typeof Swiper === 'undefined') {
          setTimeout(initSwiperInstance, 100);
          return;
        }

        new Swiper(swiperContainer, {
          slidesPerView: 1.2,
          spaceBetween: 12,
          centeredSlides: false,
          lazy: true,
          navigation: {
            nextEl: swiperContainer.querySelector('.swiper-button-next'),
            prevEl: swiperContainer.querySelector('.swiper-button-prev'),
          },
          pagination: {
            el: swiperContainer.querySelector('.swiper-pagination'),
            clickable: true,
          },
          breakpoints: {
            375: {
              slidesPerView: 1.28,
              spaceBetween: 12,
            },
            480: {
              slidesPerView: 1.5,
              spaceBetween: 12,
            },
            640: {
              slidesPerView: 2.2,
              spaceBetween: 16,
            },
            750: {
              slidesPerView: 3,
              spaceBetween: 24,
            },
          },
        });
      };

      initSwiperInstance();
    }

    initMediaToggle() {
      const mediaContainers = this.querySelectorAll('.yg-media-container');

      mediaContainers.forEach((container) => {
        const toggleBtns = container.querySelectorAll('.yg-media-toggle-btn');
        const mediaItems = container.querySelectorAll('.yg-media-item');

        toggleBtns.forEach((btn) => {
          btn.addEventListener('click', function () {
            const targetType = this.getAttribute('data-toggle');

            toggleBtns.forEach((b) => b.classList.remove('active'));
            this.classList.add('active');

            mediaItems.forEach((item) => {
              const itemType = item.getAttribute('data-media-type');
              if (itemType === targetType) {
                item.classList.add('active');
                if (itemType === 'video') {
                  const video = item.querySelector('video');
                  if (video) {
                    video.currentTime = 0;
                    video.play();
                  }
                }
              } else {
                item.classList.remove('active');
                if (itemType === 'video') {
                  const video = item.querySelector('video');
                  if (video) {
                    video.pause();
                  }
                }
              }
            });
          });
        });
      });
    }

    initAnimation() {
      if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
        console.warn('YGMediaCardGridAnimation: GSAP 或 ScrollTrigger 未加载');
        return;
      }

      try {
        gsap.registerPlugin(ScrollTrigger);

        const mediaBox = this.querySelector('.yg-media-box');
        const gridContainer = this.querySelector('.yg-image-text-grid');

        if (!gridContainer) {
          console.warn('YGMediaCardGridAnimation: 未找到 gridContainer');
          return;
        }

        const gridItems = gridContainer.querySelectorAll('.yg-image-text-grid-item');

        // 如果有 mediaBox，添加动画
        if (mediaBox) {
          // 检查元素是否已经在视口内
          const mediaBoxRect = mediaBox.getBoundingClientRect();
          const isInView = mediaBoxRect.top < window.innerHeight && mediaBoxRect.bottom > 0;

          if (isInView) {
            // 如果已经在视口内，直接显示，不做动画
            gsap.set(mediaBox, { opacity: 1, y: 0 });
          } else {
            // 不在视口内，设置初始状态并添加滚动动画
            gsap.set(mediaBox, { opacity: 0, y: 40 });

            const mediaBoxTween = gsap.to(mediaBox, {
              opacity: 1,
              y: 0,
              duration: 0.8,
              ease: 'power2.out',
              scrollTrigger: {
                trigger: mediaBox,
                start: 'top 95%',
                toggleActions: 'play none none none',
                once: true,
              },
            });

            if (mediaBoxTween && mediaBoxTween.scrollTrigger) {
              this.scrollTriggers.push(mediaBoxTween.scrollTrigger);
            }
          }
        }

        // 为所有 grid items 添加入场动效
        if (gridItems.length > 0) {
          // 检查 gridContainer 是否已经在视口内
          const gridRect = gridContainer.getBoundingClientRect();
          const isGridInView = gridRect.top < window.innerHeight * 0.8 && gridRect.bottom > 0;

          if (isGridInView) {
            // 如果已经在视口内，直接显示所有项目
            gridItems.forEach((item) => {
              gsap.set(item, { opacity: 1, y: 0 });
            });
          } else {
            // 不在视口内，设置初始状态并添加滚动动画
            gridItems.forEach((item, index) => {
              gsap.set(item, { opacity: 0, y: 40 });

              const itemTween = gsap.to(item, {
                opacity: 1,
                y: 0,
                duration: 0.8,
                ease: 'power2.out',
                delay: index * 0.15,
                scrollTrigger: {
                  trigger: gridContainer,
                  start: 'top 80%',
                  toggleActions: 'play none none none',
                  once: true,
                },
              });

              if (itemTween && itemTween.scrollTrigger) {
                this.scrollTriggers.push(itemTween.scrollTrigger);
              }
            });
          }
        }
      } catch (error) {
        console.error('YGMediaCardGridAnimation: 动画初始化失败', error);
      }
    }

    initProductCardShake() {
      const productCards = this.querySelectorAll('.yg-product-card');

      if (productCards.length === 0) return;

      this.intersectionObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.startShakeEffect(entry.target);
            } else {
              this.stopShakeEffect(entry.target);
            }
          });
        },
        {
          threshold: 0.5,
          rootMargin: '0px',
        }
      );

      productCards.forEach((card) => {
        this.intersectionObserver.observe(card);
      });
    }

    startShakeEffect(card) {
      if (this.shakeInterval) {
        clearInterval(this.shakeInterval);
      }

      this.performShake(card);

      this.shakeInterval = setInterval(() => {
        this.performShake(card);
      }, 5000);
    }

    performShake(card) {
      card.classList.remove('shake');
      void card.offsetWidth;
      card.classList.add('shake');

      setTimeout(() => {
        card.classList.remove('shake');
      }, 2500);
    }

    stopShakeEffect(card) {
      if (this.shakeInterval) {
        clearInterval(this.shakeInterval);
        this.shakeInterval = null;
      }

      card.classList.remove('shake');
    }
  }

  if (!customElements.get('yg-media-card-grid')) {
    customElements.define('yg-media-card-grid', YGMediaCardGridAnimation);
  }

  // YG Add More Button Component
  class YGAddMoreButton extends HTMLElement {
    constructor() {
      super();
      this.handleBuyMoreAdd = this.handleBuyMoreAdd.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.handleClick.bind(this));
      document.addEventListener('buy-more-add', this.handleBuyMoreAdd);
    }

    disconnectedCallback() {
      document.removeEventListener('buy-more-add', this.handleBuyMoreAdd);
    }

    handleClick(e) {
      e.preventDefault();
      const productId = this.dataset.productId;
      const productHandle = this.dataset.productHandle;

      if (!productId) {
        console.error('YGAddMoreButton: Product ID not found');
        return;
      }

      const url = `/products/${productHandle}?section_id=main-qv&style=1`;

      if (this.classList.contains('loading')) return;
      this.classList.add('loading');

      const initQuickViewPopup = () => {
        var t = $('.t4s-product-quick-view .t4s-row__product:not(.initProducts__enabled');
        t.addClass('initProducts__enabled'),
          new T4SThemeSP.Product(t[0]),
          T4SThemeSP.PopupMFP(),
          window.Shopify && Shopify.PaymentButton && Shopify.PaymentButton.init(),
          T4SThemeSP.Wishlist.updateAll(),
          T4SThemeSP.Compare.updateAll(),
          T4SThemeSP.ProductItem.reloadReview(),
          T4SThemeSP.Tooltip(),
          $('body').trigger('currency:update');

        // Initialize FlickityT4S carousels
        var d = $('.t4s-product-quick-view .flickityt4s');
        if (d.length) {
            d[0].flickityt4s = new T4SThemeSP.Carousel(d[0]);
        }
      };

      fetch(url)
        .then((response) => response.text())
        .then((html) => {
          T4SThemeSP.NTpopupInline(html, 'main-qv', initQuickViewPopup, 'scenario-opening-qv');
          $('body').trigger('modalt4s:opened');
        })
        .catch((error) => {
          console.error('YGAddMoreButton: Error fetching product data', error);
        })
        .finally(() => {
          this.classList.remove('loading');
        });
    }

    handleBuyMoreAdd(event) {
      const detail = event.detail;

      if (detail.pid !== this.dataset.productId) {
        return;
      }

      let imgUrl = detail.img || this.dataset.productImage || '';

      $('body').trigger('modalt4s:closed');

      const quantity = parseInt(detail.quantity, 10) || 1;

      // 根据数量创建多个独立的卡片
      for (let i = 0; i < quantity; i++) {
        // 为每个卡片生成唯一的 sectionId
        const sectionId = 'yg-add-more-section-' + detail.id + '-' + Date.now() + '-' + i + '-' + Math.random().toString(36).substr(2, 9);
        const selectedVariants = [
          [
            detail.pid,
            [
              {
                variantId: detail.id,
                quantity: 1, // 每张卡片数量为1
                price: detail.price,
                price_not_formatted: parseInt(detail.price, 10) || 0,
                image: imgUrl,
                options: [],
              },
            ],
          ],
        ];
        const variantCheckState = [[detail.id, true]];

        setTimeout(() => {
          document.dispatchEvent(
            new CustomEvent('productSelectionChanged', {
              detail: {
                sectionId: sectionId,
                selectedVariants: selectedVariants,
                variantCheckState: variantCheckState,
              },
            })
          );
        }, 100 + i * 50); // 每个卡片延迟50ms，创造动画效果
      }

      this.playDropAnimation(quantity);
    }

    playDropAnimation(quantity) {
      const notification = this.querySelector('.yg-purchase-success-notification');
      const payBar = document.querySelector('.yg-pay-now-bar-inner');
      if (!notification || !payBar) return;

      const rect = notification.getBoundingClientRect();
      const computedStyle = window.getComputedStyle(notification);

      const flyer = notification.cloneNode(true);
      flyer.classList.add('yg-purchase-success-notification');
      flyer.style.position = 'fixed';
      flyer.style.left = rect.left + 'px';
      flyer.style.top = rect.top + 'px';
      flyer.style.zIndex = '9999';
      flyer.style.opacity = '1';
      flyer.style.margin = '0';

      flyer.style.width = computedStyle.width;
      flyer.style.height = computedStyle.height;
      flyer.style.background = computedStyle.background;
      flyer.style.color = computedStyle.color;
      flyer.style.borderRadius = computedStyle.borderRadius;
      flyer.style.fontSize = computedStyle.fontSize;
      flyer.style.fontWeight = computedStyle.fontWeight;
      flyer.style.display = computedStyle.display;
      flyer.style.alignItems = computedStyle.alignItems;
      flyer.style.justifyContent = computedStyle.justifyContent;

      flyer.textContent = quantity;

      document.body.appendChild(flyer);

      let targetRect;

      if (payBar) {
        const tempRect = payBar.getBoundingClientRect();
        if (tempRect.width > 0 && tempRect.height > 0) {
          targetRect = tempRect;
        } else {
          targetRect = {
            left: 0,
            top: window.innerHeight - 100,
            width: window.innerWidth,
            height: 100,
          };
        }
      } else {
        targetRect = {
          left: 0,
          top: window.innerHeight - 100,
          width: window.innerWidth,
          height: 100,
        };
      }

      const targetX = targetRect.left + targetRect.width / 2 - rect.width / 2;
      const targetY = targetRect.top;

      const deltaX = targetX - rect.left;
      const deltaY = targetY - rect.top;

      const isMobile = window.innerWidth < 700;
      const parabolaDirection = isMobile ? 120 : -120;

      if (typeof gsap !== 'undefined') {
        gsap.to(flyer, {
          duration: 1.2,
          keyframes: {
            '0%': { x: 0, y: 0, opacity: 1, scale: 1 },
            '40%': {
              x: parabolaDirection,
              y: -120,
              opacity: 1,
              scale: 1,
              ease: 'power1.out',
            },
            '100%': {
              x: deltaX,
              y: deltaY,
              opacity: 0,
              scale: 0.5,
              ease: 'power2.in',
            },
          },
          onComplete: () => {
            flyer.remove();
          },
        });
      } else {
        flyer.style.transition = 'all 1.2s ease';
        flyer.style.transform = `translate(${deltaX}px, ${deltaY}px) scale(0.5)`;
        flyer.style.opacity = '0';
        setTimeout(() => flyer.remove(), 1200);
      }
    }
  }

  if (!customElements.get('yg-add-more-button')) {
    customElements.define('yg-add-more-button', YGAddMoreButton);
  }

  // Buy More Add Button Component
  if (!customElements.get('buy-more-add-button')) {
    class BuyMoreAddButton extends HTMLElement {
      constructor() {
        super();
        this.clickHandler = this.handleClick.bind(this);
        this.variantChangeHandler = this.handleVariantChange.bind(this);
        this.addEventListener('click', this.clickHandler);
      }

      connectedCallback() {
        // 监听变体变化事件
        const productFeatured = this.closest('[data-product-featured]');
        if (productFeatured) {
          $(productFeatured).on('variant:changed', this.variantChangeHandler);
        }
      }

      disconnectedCallback() {
        const productFeatured = this.closest('[data-product-featured]');
        if (productFeatured) {
          $(productFeatured).off('variant:changed', this.variantChangeHandler);
        }
      }

      handleVariantChange(e) {
        const variant = e.currentVariant;
        const btnText = this.querySelector('.t4s-btn-atc_text');
        const qtyWrapper = this.closest('.t4s-pr__qty_cart')?.querySelector('[data-quantity-wrapper]');
        
        if (!variant || variant === 'nathan') {
          // 无效变体
          this.setAttribute('disabled', 'disabled');
          this.setAttribute('aria-disabled', 'true');
          if (btnText) btnText.textContent = window.T4SProductStrings?.unavailable || 'Unavailable';
          if (qtyWrapper) qtyWrapper.style.display = 'none';
        } else if (variant.available) {
          // 有库存
          this.removeAttribute('disabled');
          this.removeAttribute('aria-disabled');
          if (btnText) btnText.textContent = window.T4SProductStrings?.addToCart || 'Add to cart';
          if (qtyWrapper) qtyWrapper.style.display = '';
        } else {
          // 售罄
          this.setAttribute('disabled', 'disabled');
          this.setAttribute('aria-disabled', 'true');
          if (btnText) btnText.textContent = window.T4SProductStrings?.soldOut || 'Sold out';
          if (qtyWrapper) qtyWrapper.style.display = 'none';
        }
      }

      handleClick(e) {
        e.preventDefault();
        
        // 检查按钮是否被禁用
        if (this.hasAttribute('disabled') || this.getAttribute('aria-disabled') === 'true') {
          return;
        }
        
        const container = $(this).closest('.t4s-product-form__variants');
        const form = container.find('form').get(0);
        const data = new FormData(form);
        const allData = JSON.parse(container.find('.pr_variants_json').html());
        const item = allData.find((item) => item.id == data.get('id'));
        
        // 再次检查变体是否可用
        if (!item || !item.available) {
          return;
        }
        
        const info = {
          id: item.id,
          quantity: data.get('quantity'),
          pid: data.get('product-id'),
          price: item.price,
          img: item.featured_image?.src || container.data('img'),
          type: this.dataset.type,
        };
        document.dispatchEvent(new CustomEvent('buy-more-add', { detail: info }));
        $('body').trigger('modalt4s:closed');
      }
    }
    customElements.define('buy-more-add-button', BuyMoreAddButton);
  }
});